module.exports = __webpack_public_path__ + "img/zhanglifang.b7f78968.jpg";